export default {"src":"/_next/static/media/hear-no-evil-own.4fc5f825.svg","height":100,"width":100};